import { Component, ElementRef, Input, OnDestroy, ViewChild } from "@angular/core";

import type { ChatRuntimeController } from './chat-runtime.controller';

@Component({
  selector: "app-chat-sources-panel",
  templateUrl: "./chat-sources-panel.component.html",
  host: { style: "display: contents" },
  standalone: false
})
export class ChatSourcesPanelComponent implements OnDestroy {
  @Input({ required: true }) view!: ChatRuntimeController;

  @ViewChild("detailsPanel")
  set detailsPanel(value: ElementRef<HTMLElement> | undefined) {
    this.view.state.detailsPanel = value;
  }

  ngOnDestroy(): void {
    this.view.state.detailsPanel = undefined;
  }
}
